import { type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useIsAuthenticated } from '@azure/msal-react';
import { isDevAuthBypass } from '@/auth/index';

/**
 * Route guard. Entra sign-in is required unconditionally (this is an internal app; there is no
 * signed-link fallback). The API enforces the @claridynamics.com domain gate independently, so
 * a non-CDX Entra identity that somehow authenticates still gets nothing from the data endpoints.
 */
export function AuthRoute({ children }: { children: ReactNode }) {
  const isAuthenticated = useIsAuthenticated();
  const location = useLocation();
  if (isDevAuthBypass()) return <>{children}</>;
  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return <>{children}</>;
}
